const XIcon = ({className} : {className?:string}) => {
  return (
<svg className={className} width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.582 0H17.342L11.312 6.77822L18.4062 16H12.8517L8.50175 10.4063L3.52325 16H0.76175L7.21175 8.74973L0.40625 0.0007376H6.10175L10.034 5.11354L14.582 0ZM13.6138 14.3759H15.143L5.27075 1.5393H3.62975L13.6138 14.3759Z" fill="currentColor"/>
</svg>
  )
}

export default XIcon